import { gql } from "@apollo/client";

export const UPDATE_VIRTUAL_ACCOUNT_OVERDRAFT_LIMIT = gql`
    mutation UpdateVirtualAccountOverdraftLimit($virtualAccountId: Long!, $overdraftLimit: Long!) {
        updateVirtualAccountOverdraftLimit(virtualAccountId: $virtualAccountId, overdraftLimit: $overdraftLimit)
    }
`;

export interface UpdateVirtualAccountOverdraftLimitResponse {
    updateVirtualAccountOverdraftLimit: boolean;
}

export interface UpdateVirtualAccountOverdraftLimitVariables {
    virtualAccountId: number;
    overdraftLimit: number;
}

